var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
// While this literally just runs Array.isArray TS doesn't pick up on it
// quite as well if we don't use a type guard.
// https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
export var checkIfArray = function (message) {
    return Array.isArray(message);
};
export function createStringsFromJSON(message, recur) {
    if (recur === void 0) { recur = false; }
    if (checkIfArray(message) && !recur) {
        return message.map(function (details) {
            return createStringsFromJSON(details, true);
        });
    }
    if (typeof message === 'object') {
        return JSON.stringify(message, null, 2);
    }
    return message;
}
export var joinLevelAndNamespace = function (opts) {
    var level = opts.level, nameSpace = opts.nameSpace, label = opts.label;
    if (label) {
        return nameSpace + "-" + label + ": ";
    }
    return nameSpace + "-" + level + ": ";
};
// The default formatter for node. Works well with console.log/trace as an
// output.
export var nodeConsoleFormatter = function (opts) {
    var message = opts.message, color = opts.color;
    var stringifiedJSON = createStringsFromJSON(message);
    var levelAndNameSpace = "" + color + joinLevelAndNamespace(opts);
    var isArray = checkIfArray(stringifiedJSON);
    if (isArray) {
        return __spread([
            "" + levelAndNameSpace + stringifiedJSON[0]
        ], stringifiedJSON.slice(1), [
            '\x1b[0m',
        ]);
    }
    return "" + levelAndNameSpace + stringifiedJSON + "\u001B[0m";
};
// The default formatter for web. Works well with console.log/trace as an
// output. Though the nodeConsoleFormatter will work here as well, the web
// version gives you much more flexibility with styling.
export var webConsoleFormatter = function (opts) {
    var message = opts.message, color = opts.color, meta = opts.meta;
    var stringifiedJSON = createStringsFromJSON(message);
    var levelAndNameSpace = "%c" + joinLevelAndNamespace(opts);
    var isArray = checkIfArray(stringifiedJSON);
    var additionalStyles = (meta && meta.styles && ";" + meta.styles) || '';
    if (isArray) {
        return __spread([
            "" + levelAndNameSpace + stringifiedJSON[0],
            "color: " + color + additionalStyles
        ], stringifiedJSON.slice(1));
    }
    var levelAndMessage = [
        "" + levelAndNameSpace + stringifiedJSON,
        "color: " + color + additionalStyles,
    ];
    return levelAndMessage;
};
//# sourceMappingURL=index.js.map